import React, { useMemo } from 'react'
import Loadable from 'react-loadable'
import LoadingIndicator from '../LoadingIndicator'

type Icon = {
  width: string | number;
  height: string | number;
  rotate: string | number;
  icon: string;
  color: string;
  directory: string;
  className: string;
}

function Icon ({ width, height, icon, color, rotate, directory, className }: Icon) {
  const SvgIcon = useMemo(() => (
    Loadable({
      loader: () => import(`inter-frontend-svgs/lib/${directory}/${icon}`),
      loading: () => <LoadingIndicator size='small' />,
    })
  ), [])

  return (
    <SvgIcon width={width} height={height} icon={icon} color={color} rotate={rotate} directory={directory} className={className} />
  )
}

Icon.defaultProps = {
  width: '',
  height: '',
  icon: '',
  color: 'orange--base',
  rotate: 0,
  directory: '',
  className: '',
}

export default Icon
